import { LocationType } from './location-type.js';
export const REQUIRED_LOCATION_TYPE_LABELS = new Map([
    [LocationType.STOCK, 'Stock'],
    [LocationType.RECEIVING, 'Receiving'],
]);
export function requiredLocationTypeMessage(typeLabel) {
    return `This warehouse must keep at least one active ${typeLabel} location.`;
}
//# sourceMappingURL=required-location-types.js.map